// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rB5jspMnPi4PBMH5mcxD{grid-gap:24px 16px;flex:1;grid-template-columns:repeat(auto-fill,120px);margin-right:-20px;padding-top:24px;display:grid;overflow-y:auto}.bTRYhEWQWj4xXMy_fFZ6{grid-column:1/-1;justify-content:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridView": `rB5jspMnPi4PBMH5mcxD`,
	"spinnerMoreContainer": `bTRYhEWQWj4xXMy_fFZ6`
};
export default ___CSS_LOADER_EXPORT___;
